import { HeatmapAggregationFn } from '@warebee/shared/common';
import { ReferenceExpression, SelectQueryBuilder } from 'kysely';

export function getAggregatedFunction<DB, O>(
  query: SelectQueryBuilder<DB, keyof DB, O>,
  aggregationFn: HeatmapAggregationFn,
  groupBy: ReferenceExpression<DB, keyof DB>,
) {
  switch (aggregationFn) {
    case 'count-locations':
      return query.select(({ fn, ref }) =>
        fn.count(groupBy).distinct().as('dimensionValue'),
      );
    case 'count':
      return query.select(({ fn }) => fn.count(groupBy).as('dimensionValue'));
    case 'avg':
      return query.select(({ fn }) => fn.avg(groupBy).as('dimensionValue'));
    case 'max':
      return query.select(({ fn }) => fn.max(groupBy).as('dimensionValue'));
    case 'min':
      return query.select(({ fn }) => fn.min(groupBy).as('dimensionValue'));
    case 'sum':
      return query.select(({ fn }) => fn.sum(groupBy).as('dimensionValue'));
  }
}
